import { Component, Input } from '@angular/core';
import { Notification } from '@shared/models/notification.model';
import { BaseComponent } from '@shared/components/base.component';
import { Config } from '@shared/config';

@Component({
  selector: 'app-notification-content',
  templateUrl: './notification-content.component.html',
  styleUrls: ['./notification-content.component.scss'],
})
export class NotificationContentComponent extends BaseComponent {
  @Input() item: Notification;

  constructor() {
    super();
  }

  get notificationUserType() {
    return Config.NOTIFICATION_TYPE_USER.indexOf(this.item.type) > -1;
  }

  get notificationAchievementType() {
    return Config.NOTIFICATION_TYPE_ACHIEVEMENT.indexOf(this.item.type) > -1;
  }

  get notificationProjectType() {
    return Config.NOTIFICATION_TYPE_PROJECT.indexOf(this.item.type) > -1;
  }
}
